/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import dismissal from "../../assets/icons/employment/IconDismissal";

const linkedCardsHomePage = [
  {
    icon: dismissal,
    heading: "Kündigung",
    subHeading: "Professionell und schnell prüfen lassen und dagegen angehen",
    link: "/arbeit/kuendigung",
  },
];

export default linkedCardsHomePage;
